import { Partial } from '@40seas/entities/common';
import { User } from './user.entity';
import { CreateBuyerUserDto, CreateSupplierUserDto } from './create.user.dto';

export class UpdateUserDto extends Partial(User) {}

export class UpdateSupplierUserDto extends Partial(CreateSupplierUserDto) {}

export class UpdateUserWithIdDto extends UpdateUserDto {
    id: string;
}

export class UpdateBuyerUserDto extends Partial(CreateBuyerUserDto) {}
